import React from "react"

import styled from "styled-components"

import { Settings } from "../../../styles/theme"

const Inputstyled = styled.div`
  flex: 1 1 ${props => (props.width ? props.width - 3 : 100)}% !important;
  margin: 5px;
  > input {
    box-sizing: border-box;
    background: none;
    width: 100%;
    border: 2px solid
      ${props => (props.valid ? "rgba(0, 0, 0, 0.6)" : "red !important")};
    padding: 0.5rem;
    outline: none;
    transition: border 125ms ease-in-out;
    &:focus {
      border: 2px solid ${Settings.primaryColor};
    }
    &:disabled {
      background: #ccc;
    }
  }
`

export const TextInput = ({
  placeholder,
  name,
  className,
  callback,
  width,
  valid,
  value,
  disabled,
}) => (
  <Inputstyled width={width} valid={valid}>
    <input
      className={className}
      name={name}
      onChange={callback}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
    />
  </Inputstyled>
)

const Checkboxstyled = styled.div`
  position: relative;
  white-space: nowrap;
  display: flex;
  align-items: flex-start;
  margin: 1rem 0;
  input {
    width: 5%;
  }
  label {
    width: 90%;
  }
  label {
    white-space: normal;
    display: inline-block;
    p {
      display: inline-block;
      margin: 0 1rem;
    }
  }
`

export const Checkbox = ({ data, state, callback }) => (
  <Checkboxstyled onClick={() => callback(data.title)}>
    <input type="checkbox" name={data.title} checked={state} />
    <label
      htmlFor={data.title}
      dangerouslySetInnerHTML={{ __html: data.content }}
    />
  </Checkboxstyled>
)
